import moment from 'moment-timezone';

export const defaultDatePickerFormat = 'dd/MM/yyyy';
export const defaultDatePickerValueFormat = 'yyyy-MM-dd';

// Convert a stored "HH:mm" string into a Date a time-only picker can select,
// and back again on change — the backend contract stays a plain "HH:mm" string.
export const timeStringToDate = (timeStr) => {
    if (!timeStr) {
        return null;
    }
    const [hours, minutes] = timeStr.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
};

export const formatDate = (dateObj) => {
    var d = !(dateObj instanceof Date) ? new Date(dateObj) : dateObj;
    var month = '' + (d.getMonth() + 1);
    var day = '' + d.getDate();
    var year = d.getFullYear();
    month = month.length < 2 ? '0' + month : month;
    day = day.length < 2 ? '0' + day : day;
    return [day, month, year].join('-');
};

// format a Date object or a string into "hh:mm" format
export const formatTime = (timeObj) => {
    var t = !(timeObj instanceof Date) ? new Date(timeObj) : timeObj;
    var hour = '' + t.getHours();
    var minutes = '' + t.getMinutes();
    hour = hour.length < 2 ? (hour = '0' + hour) : hour;
    minutes = minutes.length < 2 ? (minutes = '0' + minutes) : minutes;
    return hour + ':' + minutes;
};

export const timeFieldInit = ($this) => {
    let options = {
        interval: 5,
        timeFormat: 'HH:mm',
        dynamic: false,
    };
    if ($this.data('min')) {
        options.minTime = $this.data('min');
    }
    if ($this.data('max')) {
        options.maxTime = $this.data('max');
    }
    $this.timepicker(options);
    // $this.on("blur", function () {
    // 	$this.timepicker("hideWidget");
    // });
};

export const dateFieldInit = ($this) => {
    let options = {
        dateFormat: 'dd-mm-yy',
        changeMonth: true,
        changeYear: true,
        yearRange: '-10:+20',
        onSelect: function (dateText) {
            restrictDates($this, dateText);
        },
        beforeShow: function (textbox, instance) {},
    };
    if ($this.data('min')) {
        options.minDate = $this.data('min');
    }
    if ($this.data('max')) {
        options.maxDate = $this.data('max');
    }
    $this.datepicker(options);
};

export const createModalOverlay = () => {
    return (
        '<div class="modal-loading-overlay tw-absolute tw-inset-0 tw-bg-white tw-bg-opacity-75 tw-flex tw-items-center tw-justify-center tw-z-50 tw-rounded-lg">' +
        '<div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>' +
        '</div>'
    );
};

export const submitByAjax = ($form, $modal, $button, modalSelector = '', options = {}) => {
    const showFeedback = !!options.showFeedback;
    $button.addClass('disabled');
    $button.prop('disabled', true);
    if (showFeedback) {
        const overlayHtml = createModalOverlay();
        $modal.find('.modal__inner-container').append(overlayHtml);
    }
    var scheduleAction = $modal.data('action');
    var data = $form.serialize();
    var action = $form.attr('action');
    let cleanupOwnedByCloseTimer = false;
    $.ajax({
        method: 'POST',
        url: action,
        data: data,
        beforeSend: function () {
            $modal.find('.alert').remove();
        },
    })
        .fail(function (jqXHR, textStatus, errorThrown) {
            if (422 == jqXHR.status) {
                var response = jqXHR.responseJSON;
                var messages = '<div class="alert alert-danger"><ul>';
                for (var property in response.errors) {
                    if (Object.prototype.hasOwnProperty.call(response.errors, property)) {
                        messages += '<li>' + response.errors[property][0] + '</li>';
                    }
                }
                messages += '</ul></div>';
                $(messages).insertBefore($form);
            } else if (showFeedback && typeof window.showToast === 'function') {
                window.showToast($t('An error occurred, please try again'), 'error');
            }
        })
        .done(function (response, textStatus, xhr) {
            if (response.message && response.url) {
                cleanupOwnedByCloseTimer = true;
                if (showFeedback && typeof window.showToast === 'function') {
                    window.showToast(response.message, 'info');
                }
                window.location.href = response.url;
                return;
            }

            cleanupOwnedByCloseTimer = true;

            if ('add' === scheduleAction) {
                calendar.addEvent(response);
            } else {
                var event = calendar.getEventById(response.id);
                event.setProp('title', response.title);
                event.setDates(response.start, response.end, { allDay: false });
                if (response.venue_id !== null) {
                    $(`.fc-event[data-novenue="${response.scheduleId}"]`).removeClass('bg-danger');
                    $('#novenue-sessions').find(`tr[data-schedule_id="${response.scheduleId}"]`).remove();
                }
            }
            calendar.refetchEvents();

            if (showFeedback) {
                if (typeof window.showToast === 'function') {
                    window.showToast($t('Changes saved successfully'), 'success');
                }
                setTimeout(function () {
                    $modal.find('.modal-loading-overlay').remove();
                    $button.removeClass('disabled');
                    $button.prop('disabled', false);
                    let modalInstance = FlowbiteInstances.getInstance('Modal', modalSelector);
                    if (modalInstance) {
                        hideFlowbiteModal(modalInstance, modalSelector);
                    }
                }, 1000);
            } else {
                let modalInstance = FlowbiteInstances.getInstance('Modal', modalSelector);
                if (modalInstance) {
                    hideFlowbiteModal(modalInstance, modalSelector);
                }
            }
        })
        .always(function () {
            if (!cleanupOwnedByCloseTimer) {
                $modal.find('.modal-loading-overlay').remove();
                $button.removeClass('disabled');
                $button.prop('disabled', false);
            }
        });
};

export const restrictDates = ($this, dateText) => {
    let groupName = $this.data('group');
    let $group = $('[data-group=' + groupName + ']');
    let thisOrder = $this.data('order');
    const $prev = $('[data-group=' + groupName + '][data-order=' + (thisOrder - 1) + ']');
    if ($prev.length) {
        $prev.datepicker('option', { maxDate: dateText });
    }
    const $next = $('[data-group=' + groupName + '][data-order=' + (thisOrder + 1) + ']');
    if ($next.length) {
        $next.datepicker('option', { minDate: dateText });
    }
};

export const tzName = moment.tz(moment.tz.guess()).zoneAbbr();
export const fullTzName = moment.tz(moment.tz.guess()).tz();

export const formatDateWithTz = (value, fromFormat = 'YYYY-MM-DD HH:mm:ss', toFormat = 'YYYY-MM-DD HH:mm:ss', tz = null) => {
    const timezoneName = tz || fullTzName;

    return value ? moment.utc(value, fromFormat).tz(timezoneName).format(toFormat) : value;
};

// jquery ui date with month/year only
export const monthFieldInit = ($this) => {
    var options = {
        changeMonth: true,
        changeYear: true,
        showButtonPanel: true,
        dateFormat: 'MM yy',
        onClose: function (dateText, inst) {
            $this.datepicker('setDate', new Date(inst.selectedYear, inst.selectedMonth, 1));
        },
    };
    $this.datepicker(options);
};

// jquery ui date with month only
export const singleMonthFieldInit = ($this) => {
    var options = {
        changeMonth: true,
        ChangeYear: false,
        showButtonPanel: true,
        dateFormat: 'MM',
        onClose: function (input, inst) {
            var month = $('#ui-datepicker-div .ui-datepicker-month :selected').val();
            $(this)
                .datepicker('setDate', new Date(new Date().getFullYear(), month, 1))
                .trigger('change');
            inst.dpDiv.removeClass('single-month-datepicker');
        },
        beforeShow: function (input, inst) {
            inst.dpDiv.addClass('single-month-datepicker');
        },
    };
    $this.datepicker(options);
};

// jquery ui with day/month only
export const dayMonthFieldInit = ($this) => {
    var options = {
        changeMonth: true,
        changeYear: false,
        showButtonPanel: true,
        dateFormat: 'dd-mm',
        onSelect: function (dateText) {
            restrictDates($this, dateText);
        },
    };
    if ($this.data('min')) {
        options.minDate = $this.data('min');
    }
    if ($this.data('max')) {
        options.maxDate = $this.data('max');
    }
    $this.datepicker(options).focus(function () {
        $('.ui-datepicker-year').hide();
    });
};

export const singleDayFieldInit = ($this) => {
    var options = {
        changeMonth: false,
        changeYear: false,
        showButtonPanel: true,
        dateFormat: 'dd',
        setDate: new Date().getFullYear() + '/01/01',
    };
    $this.datepicker(options);
};

export const monthYearFieldInit = ($this) => {
    var options = {
        changeMonth: true,
        changeYear: true,
        showButtonPanel: true,
        dateFormat: 'mm-yy',
        onClose: function () {
            var iMonth = $('#ui-datepicker-div .ui-datepicker-month :selected').val();
            var iYear = $('#ui-datepicker-div .ui-datepicker-year :selected').val();
            $(this).datepicker('setDate', new Date(iYear, iMonth, 1));
        },

        beforeShow: function (input, inst) {
            var tmp = $(this).val().split('-');
            $(this).datepicker('option', 'defaultDate', new Date(tmp[1], tmp[0] - 1, 1));
            $(this).datepicker('setDate', new Date(tmp[1], tmp[0] - 1, 1));
            $('#ui-datepicker-div').addClass('mm-yyyy-datepicker');
        },
    };
    $this.datepicker(options);
};

document.addEventListener('DOMContentLoaded', function () {
    if ($('.date-input').length) {
        $('.date-input').each(function () {
            dateFieldInit($(this));
        });
    }
    if ($('.month-year-input').length) {
        $('.month-year-input').each(function () {
            monthYearFieldInit($(this));
        });
    }
    if ($('.month-input').length) {
        $('.month-input').each(function () {
            monthFieldInit($(this));
        });
    }
    if ($('.single-month-input').length) {
        $('.single-month-input').each(function () {
            singleMonthFieldInit($(this));
        });
    }
    if ($('.day-month-input').length) {
        $('.day-month-input').each(function () {
            dayMonthFieldInit($(this));
        });
    }
    if ($('.single-day-input').length) {
        $('.single-day-input').each(function () {
            singleDayFieldInit($(this));
        });
    }
});
